import { render, staticRenderFns } from "./screenErrorController.vue?vue&type=template&id=578df233"
import script from "./screenErrorController.vue?vue&type=script&lang=js"
export * from "./screenErrorController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports